module.exports = __webpack_public_path__ + "img/ls.533cb320.svg";